import BaseApi from '../../baseApi';

export default class ZapiApi extends BaseApi {
  constructor(obj) {
    obj = obj || {};
    super(obj);
  }

  /**
   * Verifica se um numero e WhatsApp.
   * @param {string} phone - Numero completo (DDI + numero, apenas digitos)
   * @returns {Promise<{ data: { isWhatsapp: boolean|null, error?: boolean } }>}
   */
  async checkWhatsApp(phone) {
    try {
      return await this.api.post('/whatsapp/check-phone', { phone });
    } catch {
      return { data: { isWhatsapp: null, error: true } };
    }
  }

  /**
   * Persiste o resultado da verificacao WhatsApp direto no banco.
   * @param {number} customerId - ID do cliente
   * @param {boolean|null} isWhatsapp - Resultado da verificacao
   * @returns {Promise<{ data: { isWhatsapp: boolean|null } }>}
   */
  async patchIsWhatsapp(customerId, isWhatsapp, cellphone, ddiCellphone) {
    try {
      return await this.api.patch(`/whatsapp/customers/${customerId}/is-whatsapp`, { isWhatsapp, cellphone, ddiCellphone });
    } catch {
      return { data: { error: true } };
    }
  }

  /**
   * Envia mensagem de texto via WhatsApp.
   * @param {string} phone - Numero completo (DDI + numero)
   * @param {string} message - Texto da mensagem
   * @returns {Promise<{ data: { sent: boolean } }>}
   */
  async sendMessage(phone, message, customerId, operationId) {
    try {
      return await this.api.post('/whatsapp/send-message', { phone, message, customerId, operationId });
    } catch {
      return { data: { sent: false, error: true } };
    }
  }

  /**
   * Obtém o QR code da instância Z-API.
   * @returns {Promise<{ data: { value: string } }>}
   */
  async getQrCode() {
    try {
      return await this.api.get('/whatsapp/instance/qr-code');
    } catch {
      return { data: { error: true } };
    }
  }

  /**
   * Obtém o status da instância Z-API.
   * @returns {Promise<{ data: { connected: boolean, smartphoneConnected: boolean, error: string } }>}
   */
  async getInstanceStatus() {
    try {
      return await this.api.get('/whatsapp/instance/status');
    } catch {
      return { data: { error: true } };
    }
  }

  /**
   * Obtém informações do dispositivo conectado (número, nome, foto, tipo).
   * @returns {Promise<{ data: { phone: string, imgUrl: string, about: string, name: string, device: object, originalDevice: string, sessionId: number, isBusiness: boolean } }>}
   */
  async getDevice() {
    try {
      return await this.api.get('/whatsapp/instance/device');
    } catch {
      return { data: { error: true } };
    }
  }

  /**
   * Obtém dados e configurações da instância Z-API.
   * @returns {Promise<{ data: { id: string, name: string, due: number, connected: boolean, paymentStatus: string, created: string } }>}
   */
  async getInstanceData() {
    try {
      return await this.api.get('/whatsapp/instance/me');
    } catch {
      return { data: { error: true } };
    }
  }

  /**
   * Desconecta o número WhatsApp da instância Z-API.
   * @returns {Promise<{ data: { value: boolean } }>}
   */
  async disconnect() {
    try {
      return await this.api.post('/whatsapp/instance/disconnect');
    } catch {
      return { data: { error: true } };
    }
  }
}
